module.exports = __webpack_public_path__ + "static/media/24.958b731d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/24.jpg
// module id = 393
// module chunks = 0